import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param field Complete form
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function oneIndicatorCheckedValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  let oneIndicatorChecked = false;
  let msg : string = '';
  if (!model) {
    return null;
  }

  // Options checkbox parameter 
  // List of checkbox name "substrings" to check for "at least one true"

  try {
    // Iterate through the model to check if at least one option is true
    const mod = Object.entries(model);
    for (let item of mod) {
      if (oneIndicatorChecked === true)
        break;

      const item_name = item[0];
      const item_value = item[1];

      // Option centinel is a toggle. If the value of toggle is No, we don't need to check the rest
      //   The validation will pass
      if (options.centinel && options.centinel && item_name === options.centinel) {
        if (item_value === 'No') {
          // Option centinel is a toggle. If the value of toggle is No, 
          // then the oneIndicatorCheckboxes will be hidden, validation is not needed in this case
          return null;
        }

        if(item_value && typeof(item_value) === 'object' && Object.keys(item_value)[0]) {
          // Option centinel is a na checkbox. If the value of checkbox is true, 
          // then oneIndicatorCheckboxes will be hidden validation is not needed in this case, so return null  
          if(item_value[Object.keys(item_value)[0]]) {
            return null;
          }
        }
      } 
      
      

      if (options.checkboxes !== undefined && Array.isArray(options.checkboxes)) {
        for (let fieldNamePart of options.checkboxes) {
          if (item_name.includes(fieldNamePart)) {
            if (item_value === true) {
              oneIndicatorChecked = true;
              break;
            }
          }
        }
      }
    }
  } catch (err) {
    console.warn("oneIndicatorCheckedValidator Exception "+err);
  }

  if (!oneIndicatorChecked) {
     msg = "At least one option should be selected";
  }

  return !msg
  ? null
  : {
    "oneIndicatorChecked": {
      message: msg,
      errorPath: options.centinel
    }
  }
}

